export default __webpack_public_path__ + "static/media/positive.4fba4999.png";